<template>
  <b-container>
      <b-row>
      <b-col lg="4" md="4">
        <iq-card>
          <vue-element-loading :active="loading1" text="Obteniendo información ..." spinner="bar-fade-scale" />
          <template v-slot:body>
            <div class="text-center"><span>Deportistas Hombres</span></div>
            <div class="d-flex justify-content-between align-items-center">
              <div class="value-box">
                <h2 class="mb-0"><Counter :key="athletesKey" :value="athletes.men" /></h2>
                <!-- <p class="mb-0 text-secondary line-height"> 26.84% </p> -->
              </div>
              <div class="iq-iconbox iq-bg-info">
                <i class="ri-arrow-up-line" />
              </div>
            </div>
            <div class="iq-progress-bar-linear d-inline-block w-100  mt-5">
              <Progressbar :key="athletesKey" :value="athletes.men" color="info" />
            </div>
          </template>
        </iq-card>
      </b-col>
      <div class="col-md-4 col-lg-4">
        <div class="iq-card">
          <vue-element-loading :active="loading1" text="Obteniendo información ..." spinner="bar-fade-scale" />
          <div class="iq-card-body">
            <div class="text-center"><span>Deportistas Mujeres</span></div>
            <div class="d-flex justify-content-between align-items-center">
              <div class="value-box">
                <h2 class="mb-0"><Counter :key="athletesKey" :value="athletes.woman" /></h2>
                <!-- <p class="mb-0 pl-2 text-secondary line-height"> 8.64% </p> -->
              </div>
              <div class="iq-iconbox iq-bg-info">
                <i class="ri-arrow-up-line"></i>
              </div>
            </div>
            <div class="iq-progress-bar-linear d-inline-block w-100  mt-5">
              <Progressbar :key="athletesKey" :value="athletes.woman" color="info" />
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4 col-lg-4">
        <div class="iq-card">
          <vue-element-loading :active="loading1" text="Obteniendo información ..." spinner="bar-fade-scale" />
          <div class="iq-card-body">
            <div class="text-center"><span>Deportistas Otros</span></div>
            <div class="d-flex justify-content-between align-items-center">
              <div class="value-box">
                <h2 class="mb-0"><Counter :key="athletesKey" :value="athletes.others" /></h2>
                <!-- <p class="mb-0 pl-2 text-secondary line-height"> 8.64% </p> -->
              </div>
              <div class="iq-iconbox iq-bg-info">
                <i class="ri-arrow-up-line"></i>
              </div>
            </div>
            <div class="iq-progress-bar-linear d-inline-block w-100  mt-5">
              <Progressbar :key="athletesKey" :value="athletes.woman" color="info" />
            </div>
          </div>
        </div>
      </div>
    </b-row>

      <b-card class="mb-4">
          <!-- <b-button @click="addItem" variant="primary" class="mb-3 mr-1"><i class="ri-add-fill"></i>Agregar Cliente</b-button> -->
        <b-row>
            <b-col>
              <vue-element-loading :active="loading2" text="Obteniendo información ..." spinner="bar-fade-scale" />
              <b-button v-if="canCreate" @click="createUser" variant="primary" class="mb-3 mr-1"><i class="ri-add-fill"></i>Crear Usuario</b-button>
                <div class="row mb-md-2">
                    <div class="col-sm-12 col-md-6">
                        <div id="tickets-table_length" class="dataTables_length">
                            <label class="d-inline-flex align-items-center">
                                Mostrar
                                <b-form-select
                                    v-model="perPage"
                                    size="sm"
                                    class="ml-1 mr-1"
                                    :options="pageOptions"
                                ></b-form-select
                                > Clientes
                            </label>
                        </div>
                    </div>
                    <!-- Search -->
                    <div class="col-sm-12 col-md-6">
                        <div
                            id="tickets-table_filter"
                            class="dataTables_filter text-md-right"
                        >
                            <label class="d-inline-flex align-items-center">
                                Buscar:
                                <b-form-input
                                    v-model="filter"
                                    type="search"
                                    placeholder="Filtra buscando aquí"
                                    class="form-control form-control-sm ml-2"
                                ></b-form-input>
                            </label>
                        </div>
                    </div>
                    <!-- End search -->
                </div>
                <b-table
                :items="data"
                :fields="fields"
                :per-page="perPage"
                :current-page="currentPage"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
                @row-clicked="rowClicked"
                show-empty
                empty-text="Sin datos para mostrar"
                hover
                head-variant="light">
                    <template #cell(actions)="data">
                        <i class="las la-pen pointer" @click="editItem(data.item.key)"></i>
                        <i class="las la-trash pointer" @click="deleteItem(data.item.key)"></i>
                    </template>
                </b-table>
                <div class="row">
                    <div class="col">
                        <div
                            class="dataTables_paginate paging_simple_numbers float-right"
                        >
                            <ul class="pagination pagination-rounded mb-0">
                                <!-- pagination -->
                                <b-pagination
                                    v-model="currentPage"
                                    :total-rows="rows"
                                    :per-page="perPage"
                                ></b-pagination>
                            </ul>
                        </div>
                    </div>
                </div>
            </b-col>
        </b-row>
      </b-card>

  </b-container>
</template>
<script>
import { core } from '@/config/pluginInit'
import axios from 'axios'
import Counter from '@/components/core/counter/Counter'

export default {
  name: 'Clientes',
  components: {
    Counter
  },
  data () {
    return {
      loading1: true,
      loading2: true,
      loading3: true,
      perPage: 10,
      currentPage: 1,
      data: [],
      filter: null,
      filterOn: [],
      pageOptions: [10, 25, 50, 100],
      fields: [
        { key: 'item.firstName', label: 'Nombre', sortable: true },
        { key: 'item.lastName', label: 'Apellido', sortable: true },
        { key: 'item.email', label: 'Correo Electrónico', sortable: true },
        { key: 'item.phoneNumber', label: 'Teléfono', sortable: true },
        { key: 'actions', label: 'Acciones' }
      ],
      athletesKey: 1,
      coachesKey: 10,
      athletes: {
        woman: 0,
        men: 0,
        others: 0,
      },
      coaches: {
        woman: 0,
        men: 0,
        others: 0,
      },
      calendarData: [],
      canCreate: false
    }
  },
  computed: {
    rows () {
      return this.data.length || 0
    }
  },
  methods: {
    onFiltered (filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    getData () {
      let role = JSON.parse(localStorage.getItem("permissions"));
      let company = JSON.parse(localStorage.getItem("atpro_cd"));
      axios.get(`https://us-central1-atpro-app.cloudfunctions.net/api/users/all?roleId=${role.id.trim()}&companyId=${company ? company.id.trim() : '0'}`)
        .then(r => {
          // console.log('Users List!', r.data.data)
          this.data = r.data.data.result.map(e => {
            return e
          })
          // this.totalRows = this.sports.length;
          this.loading2 = false;
        })
        .catch(e => {
          console.error('Error Address', e)
        })
    },
    addItem () {
      this.$router.push({ path: 'add-address' })
    },
    editItem (id) {
      this.$router.push({ name: 'atpro.edit-client', params: { id } })
    },
    rowClicked (row) {
      console.log(row)
      this.$router.push({ name: 'atpro.client-profile', params: { id: row.key } })
    },
    deleteItem (id) {
      axios.delete(`https://us-central1-atpro-app.cloudfunctions.net/api/users/delete/${id}`)
        .then(r => {
          console.log('Delete users!', r.data.data)
          this.getData()
        })
        .catch(e => {
          console.error('Error Deleting Address', e)
        })
    },
    getGenderGraph () {
      let role = JSON.parse(localStorage.getItem("permissions"));
      let company = JSON.parse(localStorage.getItem("atpro_cd"));
      axios.get(`https://us-central1-atpro-app.cloudfunctions.net/api/graph/athletes?roleId=${role.id.trim()}&companyId=${company ? company.id.trim() : '0'}`)
      .then(r => {
        // console.log("Athletes Data", r.data.data);
        this.athletes.woman = r.data.data.femenino;
        this.athletes.men = r.data.data.masculino;
        this.athletes.others = r.data.data.others;
        this.athletesKey++;
        this.loading1 = false;
      })
      .catch(e => {
        console.error('Error Graph Athletes', e);
      });
    },
    createUser() {
      this.$router.push({ path: 'create-user' })
    }
  },
  created () {
    this.canCreate = JSON.parse(localStorage.getItem("permissions")).permissions.includes('CREATE');
    this.getData();
    this.getGenderGraph();
  },
  mounted () {
    core.index()
  }
}
</script>
<style scoped>
tr{
  cursor: pointer !important;
}
</style>